import {DatetimeCell} from '@/shared-components/DatetimeCell'
import {MarketStatus, OnboardedCountry} from '@/types/Markets'
import ReactCountryFlag from 'react-country-flag'
import {useIntl} from 'react-intl'

export const MarketStatusBadge = ({status}: {status: MarketStatus}) => {
  const {formatMessage} = useIntl()

  return (
    <div
      data-testid={`market-status-${status}-badge`}
      data-cy={`market-status-${status}-badge`}
      className={`market-status-${status}-badge inline-flex items-center rounded px-2 py-1 text-sm font-medium`}
    >
      {formatMessage({id: `MARKETS.STATUS_${status}`})}
    </div>
  )
}

// `NA` is the North America market, not Namibia (ISO `NA`); flag-icons has no
// North America flag, so it falls back to the US one
const FLAG_CODE_OVERRIDES: Record<string, string> = {NA: 'US'}

export const CountryNameCell = ({name, code}: {name: string; code: string}) => {
  return (
    <div data-testid="country-name-cell" className="flex items-center gap-2 text-sm">
      <ReactCountryFlag
        countryCode={FLAG_CODE_OVERRIDES[code.toUpperCase()] ?? code}
        svg
        style={{
          width: '1.5em',
          height: '1.5em',
          borderRadius: '50%',
          objectFit: 'cover',
        }}
        title={code}
      />
      {`${name} (${code})`}
    </div>
  )
}

// date with the user who made the change underneath, when the backend sends it (EU only)
export const AuditCell = ({date, user}: {date?: string | null; user?: OnboardedCountry['createdBy']}) => {
  return (
    <div className="flex flex-col">
      <DatetimeCell value={date} />
      {user && (
        <span data-testid="audit-user" className="text-xs text-text-secondary">
          {user.name}
        </span>
      )}
    </div>
  )
}
